<template>
    <div>
        <small>
        {{ identity.identity }}<br>
        Level: {{ identity.level }}<br>
        Status: {{ identity.status }}<br>
        {{ identity.info }}
        </small>
    </div>
</template>

<script>
export default {
  name: 'IdentityKey',
  props: ['identity'],
  data: function () {
    return {};
  }
};
</script>
